import { StationTypeEnumSchema } from "@station/data/dto/station.dto.ts";
import * as z from "zod";

export const ReportStationSummaryDtoSchema = z.object({
    id: z.number(),
    code: z.string().trim(),
    name: z.string().trim(),
    technical_name: z.string().trim().nullable(),
    type: StationTypeEnumSchema.nullable(),
    icon: z.string().trim(),
    vehicle_type: z.string().trim().nullable(),
    battery_percentage: z.number().nullish(),
    spatial_levels: z.array(
        z.object({
            id: z.number(),
            name: z.string().trim(),
            to_label: z.string().trim(),
        }),
    ),
    variables: z.array(
        z.object({
            code: z.string().trim().optional(),
            icon: z.string().trim().nullable(),
            id: z.number(),
            name: z.string().trim(),
            symbol: z.string().trim().nullable(),
        }),
    ),
});

export type ReportStationSummaryDto = z.output<
    typeof ReportStationSummaryDtoSchema
>;
